











import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';


@Component({
  name: 'profile-avatar',
})
export default class ProfileAvatar extends Vue {
  @Prop(Number)
  size!: number;

  @Prop(String)
  email!: string;
}
